import React from "react";

const JMD_PER_USD = 155;

const ADDONS = [
  {
    name: "Additional Property Viewings",
    rateJMD: 15000,
    unit: "per viewing",
    desc: "Coordinate extra property visits with our representative on the ground.",
  },
  {
    name: "Virtual Property Tours",
    rateJMD: 10000,
    unit: "per session",
    desc: "Live, narrated property walk-throughs streamed to diaspora family members.",
  },
  {
    name: "Extended Post-Settlement Support",
    rateJMD: [75000, 150000],
    unit: "per month",
    desc: "Ongoing concierge after the initial 90-day settlement window.",
  },
  {
    name: "In-Home Senior Care Subscription",
    rateJMD: null,
    unit: "custom quote — hours-based",
    desc: "Regular in-home care plan tailored to weekly hours and support needs.",
  },
  {
    name: "Ongoing Relocation Concierge",
    rateJMD: null,
    unit: "bespoke quote",
    desc: "Discreet, ongoing lifestyle and logistics partner for high-needs families.",
  },
];

function fmtRange(v, currency) {
  if (v === null) return null;
  if (Array.isArray(v)) {
    const [a, b] = v;
    return currency === "JMD"
      ? `$${a.toLocaleString()} – $${b.toLocaleString()} JMD`
      : `$${Math.round(a / JMD_PER_USD)} – $${Math.round(b / JMD_PER_USD)} USD`;
  }
  return currency === "JMD"
    ? `$${v.toLocaleString()} JMD`
    : `$${Math.round(v / JMD_PER_USD)} USD`;
}

export default function AddonsSection({ currency = "JMD" }) {
  return (
    <section
      id="addons"
      data-testid="addons-section"
      className="honeycomb honeycomb--soft py-28 md:py-32 bg-[var(--gg-background)]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end mb-14">
          <div className="lg:col-span-7">
            <span className="eyebrow">À La Carte Add-Ons</span>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-[56px] text-[var(--gg-deep)] mt-5 leading-[1.05]">
              Layered support, only where it is needed.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-[var(--gg-text)] leading-relaxed">
              Every relationship begins with the $5,200 JMD initial consultation.
              From there, families select only the services that meaningfully
              improve daily life.
            </p>
          </div>
        </div>

        <div className="border-t border-gray-200">
          {ADDONS.map((a, i) => (
            <div
              key={a.name}
              data-testid={`addon-row-${i}`}
              className="group grid grid-cols-12 gap-6 py-7 border-b border-gray-200 items-start hover:bg-[var(--gg-cream)]/40 transition-colors"
            >
              <div className="col-span-1 hidden md:block">
                <span className="font-serif text-xl text-[var(--gg-primary)]/60">
                  0{i + 1}
                </span>
              </div>
              <div className="col-span-12 md:col-span-6">
                <h3 className="font-serif text-2xl text-[var(--gg-deep)]">
                  {a.name}
                </h3>
                <p className="text-sm text-[var(--gg-text-muted)] mt-2 max-w-md">
                  {a.desc}
                </p>
                {a.name === "Ongoing Relocation Concierge" && (
                  <div className="mt-5 rounded-xl overflow-hidden border border-[var(--gg-border)] bg-black max-w-md">
                    <video
                      data-testid="concierge-video"
                      src="https://customer-assets.emergentagent.com/job_diaspora-care-hub/artifacts/mzydmm6p_WhatsApp%20Video%202026-06-30%20at%2011.45.15%20PM.mp4"
                      className="w-full h-auto block"
                      controls
                      playsInline
                      preload="metadata"
                      poster=""
                    />
                  </div>
                )}
              </div>
              <div className="col-span-12 md:col-span-5 md:text-right">
                <div className="font-serif text-xl text-[var(--gg-primary)]">
                  {fmtRange(a.rateJMD, "JMD") || "Custom quote"}
                </div>
                {a.rateJMD !== null && (
                  <div className="text-xs text-[var(--gg-text-muted)] mt-1">
                    {fmtRange(a.rateJMD, "USD")}
                  </div>
                )}
                <div className="text-[11px] uppercase tracking-[0.2em] text-[var(--gg-text-muted)] mt-2">
                  {a.unit}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
